module.exports = __webpack_public_path__ + "c3d73cdac43f0587ff91dbe3ec93c534.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-icon.png
// module id = 447
// module chunks = 0